export class OpacityColorDirective {
    constructor() { }
    static factory() {
        return new OpacityColorDirective();
    }
    link(scope, element, attrs, ngModel) {
        const opacity = Number(attrs.opacityColor);
        const cell = element[0];
        if (opacity !== -1) {
            const color = `rgba(25, 195, 217, ${opacity})`;
            cell.style.backgroundColor = color;
            cell.style.color = opacity > 0.70 ? '#fff' : '#52636C';
        }
    }
}
// Explicit DI annotation for factory used in angular.directive registration
OpacityColorDirective.factory.$inject = [];
